module.exports = __webpack_public_path__ + "img/title-icon.b5ce518f.svg";